// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ITCo","title":"Footer_title__13uiG","copyright":"Footer_copyright__26I7k","email":"Footer_email__2y29y"};